
import SignInView from './account/signin';
import SignUpView from './account/signup';
import ResetPwdView from './account/resetPwd';
import SetPasswordView from './account/setPassword';
import ProfileView from './account/profile';

import CrossroadView from './crossroad';

import DashboardOverviewView from './dashboard/overview';
import DashboardOverviewV2View from './dashboard/overviewV2';
import DashboardSettingsView from './dashboard/settings';

import InsightsPerformanceView from './insights/performance';

import ToursOverviewView from './tours/overview';
import TourDetailView from './tours/detail';
import TourEditorView from './tours/editor';

import AnnouncementsOverviewView from './announcements/overview';
import AnnouncementDetailView from './announcements/detail';
import ChannelDetailView from './announcements/channelDetail';
import ChangelogsOverviewView from './changelogs/overview';
import ChangelogDetailView from './changelogs/detail';

import ContextHelpsOverviewView from './context-help/overview';
import ContextHelpDetailView from './context-help/detail';
import ContextHelpEditorView from './context-help/editor';

import SettingsIndexView from './settings';
import SettingsBillingView from './settings/billing';
import SettingsInstallView from './settings/install';
//import SettingsTrackedUsersView from './settings/trackedUsers';

import FeedbackOverviewView from './feedback/overview';
import FeedbackInboxView from './feedback/inbox';

//import ButtonOverviewView from './button/overview';
import ButtonOverviewViewV2 from './button/overviewV2';

//import SegmentsOverviewView from './segments/overview';
//import SegmentDetailView from './segments/detail';

import DebuggerOverviewView from './debugger/overview';

import VisualEventsEditorView from './visual-events/editor';

//import FlowView from './diag/flow';
//import AlertsView from './diag/alerts';

var map = new Map();

map.set('SignInView', SignInView);
map.set('SignUpView', SignUpView);
map.set('ResetPwdView', ResetPwdView);
map.set('SetPasswordView', SetPasswordView);
map.set('ProfileView', ProfileView);

map.set('CrossroadView', CrossroadView);

map.set('DashboardOverviewView', DashboardOverviewView);
map.set('DashboardOverviewV2View', DashboardOverviewV2View);
map.set('DashboardSettingsView', DashboardSettingsView);

map.set('InsightsPerformanceView', InsightsPerformanceView);

map.set('ToursOverviewView', ToursOverviewView);
map.set('TourDetailView', TourDetailView);
map.set('TourEditorView', TourEditorView);

map.set('AnnouncementsOverviewView', AnnouncementsOverviewView);
map.set('AnnouncementDetailView', AnnouncementDetailView);
map.set('ChannelDetailView', ChannelDetailView);
map.set('ChangelogsOverviewView', ChangelogsOverviewView);
map.set('ChangelogDetailView', ChangelogDetailView);

map.set('ContextHelpsOverviewView', ContextHelpsOverviewView);
map.set('ContextHelpDetailView', ContextHelpDetailView);
map.set('ContextHelpEditorView', ContextHelpEditorView);

map.set('SettingsIndexView', SettingsIndexView);
map.set('SettingsBillingView', SettingsBillingView);
map.set('SettingsInstallView', SettingsInstallView);
//map.set('SettingsTrackedUsersView', SettingsTrackedUsersView);

map.set('FeedbackOverviewView', FeedbackOverviewView);
map.set('FeedbackInboxView', FeedbackInboxView);

//map.set('ButtonOverviewView', ButtonOverviewView);
map.set('ButtonOverviewViewV2', ButtonOverviewViewV2);

//map.set('SegmentsOverviewView', SegmentsOverviewView);
//map.set('SegmentDetailView', SegmentDetailView);

map.set('DebuggerOverviewView', DebuggerOverviewView);

map.set('VisualEventsEditorView', VisualEventsEditorView);
//map.set('FlowView', FlowView);
//map.set('AlertsView', AlertsView);

export default function getRootPage(name) {
    return map.get(name);
}